const STANDARD_WHITE_1 = {
  url: 'https://res.insta360.com/static/912871246775388518767c073015fdbb/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@2x.jpg',
  urlL: 'https://res.insta360.com/static/8c9fc80e0bb84b1a53fb12adec06d9b7/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD.jpg',
  url_m:
    'https://res.insta360.com/static/912871246775388518767c073015fdbb/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@2x.jpg',
  url_s:
    'https://res.insta360.com/static/73660d78cd1728b22a8621874d7a4bc8/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@3x.jpg',
};
const STANDARD_BLACK_1 = {
  url: 'https://res.insta360.com/static/48a5f408b83d317c2ffb6fcd7dba7c2e/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/0b47aef229b559e0851cb853ecbafb0d/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91.jpg',
  url_m:
    'https://res.insta360.com/static/48a5f408b83d317c2ffb6fcd7dba7c2e/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@2x.jpg',
  url_s:
    'https://res.insta360.com/static/082a3b4d79085e53659c129c157e1571/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@3x.jpg',
};
const STANDARD_2 = {
  url: 'https://res.insta360.com/static/df8df9512b5de1bf26b83381314d709f/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@2x.jpg',
  urlL: 'https://res.insta360.com/static/e7b8887f93c8705d1fabb7629f90c409/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002.jpg',
  url_m:
    'https://res.insta360.com/static/df8df9512b5de1bf26b83381314d709f/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@2x.jpg',
  url_s:
    'https://res.insta360.com/static/f71cd1504a490b76bd4b748f4aaf0979/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@3x.jpg',
};
const STANDARD_3 = {
  url: 'https://res.insta360.com/static/62ebc65be93e8a54904237dad115a577/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@2x.jpg',
  urlL: 'https://res.insta360.com/static/bb97400bee15efab673a6e5a37d7cf8f/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003.jpg',
  url_m:
    'https://res.insta360.com/static/62ebc65be93e8a54904237dad115a577/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@2x.jpg',
  url_s:
    'https://res.insta360.com/static/24bf6d03a1e8453aeed1393cddc4f7df/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@3x.jpg',
};
const STANDARD_4 = {
  url: 'https://res.insta360.com/static/5df007f40a65f1b923e963590bcc8e15/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@2x.jpg',
  urlL: 'https://res.insta360.com/static/99fbde07f0cc6e2e75e7710e72b953b0/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004.jpg',
  url_m:
    'https://res.insta360.com/static/5df007f40a65f1b923e963590bcc8e15/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@2x.jpg',
  url_s:
    'https://res.insta360.com/static/af281989170735bd969fb4c4e48836c7/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@3x.jpg',
};
const FAMILY_WHITE_1 = {
  url: 'https://res.insta360.com/static/17c6ae7742c18e4a818ad831eca2b929/02@2x.jpg',
  urlL: 'https://res.insta360.com/static/83ba19ef42955305e586676cf9176f1b/02.jpg',
  url_m: 'https://res.insta360.com/static/17c6ae7742c18e4a818ad831eca2b929/02@2x.jpg',
  url_s: 'https://res.insta360.com/static/18cf5643e392a3a4ce76fd0d6affc161/02@3x.jpg',
};
const FAMILY_BLACK_1 = {
  url: 'https://res.insta360.com/static/521192d25727ec9a9d8431c10c8e5a13/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/453330582e6ad429d75b96599af82d13/02-%E9%BB%91.jpg',
  url_m: 'https://res.insta360.com/static/521192d25727ec9a9d8431c10c8e5a13/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/7fe3e0d95b1ac8ff6de79da01e752b61/02-%E9%BB%91@3x.jpg',
};
const FAMILY_2 = {
  url: 'https://res.insta360.com/static/b9492625a616e9d2d68f2b9ea917b26b/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/9e4f3b79c4d171ee3200d99ae0b64915/03.jpg',
  url_m: 'https://res.insta360.com/static/b9492625a616e9d2d68f2b9ea917b26b/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/9a007ca668f79d0d1e4134807cc0662c/03@3x.jpg',
};
const FAMILY_3 = {
  url: 'https://res.insta360.com/static/6b207afc8c695c73203ae8815b9d2902/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/3f7b97946bcc887c03b044a960cac34f/04.jpg',
  url_m: 'https://res.insta360.com/static/6b207afc8c695c73203ae8815b9d2902/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/03aec8979f0a30933b108a41608a47ee/04@3x.jpg',
};
const FAMILY_4 = {
  url: 'https://res.insta360.com/static/3a231ddb816bee3c8b8115ae7e87511b/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/0429e651797fb487be2408b8dadc43c6/05.jpg',
  url_m: 'https://res.insta360.com/static/3a231ddb816bee3c8b8115ae7e87511b/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/02bcc44552c25cb8f4b4c007c41a5d54/05@3x.jpg',
};
const ULTIMATE_WHITE_1 = {
  url: 'https://res.insta360.com/static/15d60b6f165cb3a75b0edf278dd485bb/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/e290f4814f9e1c3c3177908e191f5373/01.jpg',
  url_m: 'https://res.insta360.com/static/15d60b6f165cb3a75b0edf278dd485bb/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/04696be849af1b0baa76d1980ef6d8f0/01@3x.jpg',
};
const ULTIMATE_BLACK_1 = {
  url: 'https://res.insta360.com/static/4fb9a8d284ee4cd3b08648e8ce5b3867/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/d83b7cb88bae84edeee3c466afc3b113/02-%E9%BB%91.jpg',
  url_m: 'https://res.insta360.com/static/4fb9a8d284ee4cd3b08648e8ce5b3867/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/943fcf37cf131a82d82fd4f7a4cb4dad/02-%E9%BB%91@3x.jpg',
};
const ULTIMATE_2 = {
  url: 'https://res.insta360.com/static/977de0c5d32f3476bd094b00e840d20e/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/6e3d7ea75e5e85146e2e20468bf5ce13/03.jpg',
  url_m: 'https://res.insta360.com/static/977de0c5d32f3476bd094b00e840d20e/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/1349aa03a4b140acb79a70bdf2e2098b/03@3x.jpg',
};
const ULTIMATE_3 = {
  url: 'https://res.insta360.com/static/3d91d95c5295a8dd7037e01b688cbee1/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/27ad85eef22bf4116e323e08e23fe6f1/04.jpg',
  url_m: 'https://res.insta360.com/static/3d91d95c5295a8dd7037e01b688cbee1/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/09b42ed1886d6e81cc8fd8d69d479199/04@3x.jpg',
};
const ULTIMATE_4 = {
  url: 'https://res.insta360.com/static/10384bf2c970591f1c4815c1d87e9880/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/79b917006dc30ee103345baeb643543c/05.jpg',
  url_m: 'https://res.insta360.com/static/10384bf2c970591f1c4815c1d87e9880/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/92302614ef3520ea64c6cdf0f0e91f2c/05@3x.jpg',
};

const ACTION_WHITE_1 = {
  url: 'https://res.insta360.com/static/ba1b19a02825e567601c4c5ce0826031/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/81c1c328f209d4942c24c6ee8d3e08e3/01.jpg',
  url_m: 'https://res.insta360.com/static/ba1b19a02825e567601c4c5ce0826031/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/65fc6c0d4d847fb7067c3321711df7ae/01@3x.jpg',
};
const ACTION_BLACK_1 = {
  url: 'https://res.insta360.com/static/109ac6928926a13a2e86cd8d8b870e72/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/f0b19c907a0ef808380755465423e79c/02-%E9%BB%91.jpg',
  url_m: 'https://res.insta360.com/static/109ac6928926a13a2e86cd8d8b870e72/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/1455e838458932fd94a63a48316f3db9/02-%E9%BB%91@3x.jpg',
};
const ACTION_2 = {
  url: 'https://res.insta360.com/static/bcc846ae31f288a4cd0306ebfba23ac8/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/271aa3938bd2e4ecea79f6c87969c6cc/03.jpg',
  url_m: 'https://res.insta360.com/static/bcc846ae31f288a4cd0306ebfba23ac8/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/89f8b5c88697eed463a3523367a2ef72/03@3x.jpg',
};
const ACTION_3 = {
  url: 'https://res.insta360.com/static/1d5f06c09dbcb7c200b5251c630070f0/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/fa77f66f075fbd0c1e21d7f73366af5b/04.jpg',
  url_m: 'https://res.insta360.com/static/1d5f06c09dbcb7c200b5251c630070f0/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/861733c5c998665567bb03f9443a89d9/04@3x.jpg',
};

const ACTION_4 = {
  url: 'https://res.insta360.com/static/c044e28ae37bc9a9267a66b2e5737ab4/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/18ce4bd9c63829bfdecda1e61ec58b43/05.jpg',
  url_m: 'https://res.insta360.com/static/c044e28ae37bc9a9267a66b2e5737ab4/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/fe3f2dc807633b648259a9f9d28e94b1/05@3x.jpg',
};
const CREATOR_WHITE_1 = {
  url: 'https://res.insta360.com/static/86a94ae26735de36fb33ae949c962134/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/d4fc0a294ae506987112290bfad0f1b0/01.jpg',
  url_m: 'https://res.insta360.com/static/86a94ae26735de36fb33ae949c962134/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/a76670b274df9a1e0769744fe9f0b0d3/01@3x.jpg',
};
const CREATOR_BLACK_1 = {
  url: 'https://res.insta360.com/static/549706f4443c821282159bf7b5db47d8/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/abf2c3fdb87c7620b5736cd14abaa8c2/02-%E9%BB%91.jpg',
  url_m: 'https://res.insta360.com/static/549706f4443c821282159bf7b5db47d8/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/a68683d9e0753c6922ac7dfb2aea7f6e/02-%E9%BB%91@3x.jpg',
};
const CREATOR_2 = {
  url: 'https://res.insta360.com/static/915df91b8e8aedc1362b163076bfbf41/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/e5309fc96b3d5aace097e7463fb6bd45/03.jpg',
  url_m: 'https://res.insta360.com/static/915df91b8e8aedc1362b163076bfbf41/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/62700792f22b89f7e88c6cc9d13b3718/03@3x.jpg',
};
const CREATOR_3 = {
  url: 'https://res.insta360.com/static/db4dd7c9dbb38c38c9eb9221c55adfd3/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/ac20911c7b8d4adf88e44de2bb70722c/04.jpg',
  url_m: 'https://res.insta360.com/static/db4dd7c9dbb38c38c9eb9221c55adfd3/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/46d44beacb411e8ee979c80b5141786c/04@3x.jpg',
};
const CREATOR_4 = {
  url: 'https://res.insta360.com/static/0410b7cf9518f7e4ed83f356d897f5c4/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/0aa0275ddda05bab8be5caead2845067/05.jpg',
  url_m: 'https://res.insta360.com/static/0410b7cf9518f7e4ed83f356d897f5c4/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/4bda68225760b53b69b514afcc060da9/05@3x.jpg',
};
const WATER_WHITE_1 = {
  url: 'https://res.insta360.com/static/b0045955984d74493364201981606f6a/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/ae1c4843fd636d6b6a38c70b1b788a2b/01.jpg',
  url_m: 'https://res.insta360.com/static/b0045955984d74493364201981606f6a/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/ea7cb343f08eb3ac83cb3a1424703f0b/01@3x.jpg',
};
const WATER_BLACK_1 = {
  url: 'https://res.insta360.com/static/29ca9992103c463adf473bb4edde6f78/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/fbac2e2c1d105c0f0c17dffb9bbb249c/02-%E9%BB%91.jpg',
  url_m: 'https://res.insta360.com/static/29ca9992103c463adf473bb4edde6f78/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/1a7fed70ecb97ec4aa360ecff0252840/02-%E9%BB%91@3x.jpg',
};
const WATER_2 = {
  url: 'https://res.insta360.com/static/600724e3a750b2e37e4132d7fbd4817e/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/1f75a4a7e39df838c76efec2f82b4b3d/03.jpg',
  url_m: 'https://res.insta360.com/static/600724e3a750b2e37e4132d7fbd4817e/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/77a3f676d7b35311f34b08ef3e4c3ef6/03@3x.jpg',
};
const WATER_3 = {
  url: 'https://res.insta360.com/static/a3db716887836aea856faa58da9aa27d/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/1385f6984e7c67cf213c32ec5c96efda/04.jpg',
  url_m: 'https://res.insta360.com/static/a3db716887836aea856faa58da9aa27d/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/50f27cb5aa98a78125421ae96c4fb0e0/04@3x.jpg',
};

const resourcesMapperIT = new Map([
  [3125, [STANDARD_WHITE_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard white
  [3135, [STANDARD_WHITE_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard white
  [3120, [STANDARD_BLACK_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard black
  [3130, [STANDARD_BLACK_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard black
  [3121, [FAMILY_BLACK_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family black
  [3131, [FAMILY_BLACK_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family black
  [3126, [FAMILY_WHITE_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family white
  [3136, [FAMILY_WHITE_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family white
  [3469, [ULTIMATE_BLACK_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate black
  [3470, [ULTIMATE_BLACK_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate black
  [3471, [ULTIMATE_WHITE_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate white
  [3472, [ULTIMATE_WHITE_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate white
  [3122, [ACTION_BLACK_1, ACTION_2, ACTION_3, ACTION_4]], // action black
  [3132, [ACTION_BLACK_1, ACTION_2, ACTION_3, ACTION_4]], // action black
  [3127, [ACTION_WHITE_1, ACTION_2, ACTION_3, ACTION_4]], // action white
  [3137, [ACTION_WHITE_1, ACTION_2, ACTION_3, ACTION_4]], // action white
  [3478, [CREATOR_BLACK_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator black
  [3479, [CREATOR_BLACK_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator black
  [3480, [CREATOR_WHITE_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator white
  [3481, [CREATOR_WHITE_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator white
  [3123, [WATER_BLACK_1, WATER_2, WATER_3]], // water black
  [3133, [WATER_BLACK_1, WATER_2, WATER_3]], // water black
  [3128, [WATER_WHITE_1, WATER_2, WATER_3]], // water white
  [3138, [WATER_WHITE_1, WATER_2, WATER_3]], // water white
]);

export default resourcesMapperIT;
